var _defs, _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWB(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 180 180",
    style: {
      enableBackground: "new 0 0 180 180"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, " .cls-1{fill:none;}.cls-2{fill:#f8f8f8;}.cls-3,.cls-4{opacity:0.2;}.cls-4{fill:#fff;}.cls-5{fill:#1a1a1a;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "b") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 180,
    height: 180
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M87.82,16.94a12.94,12.94,0,0,0-9.5,21.73A107,107,0,0,0,63.84,52.91C53,65.83,47.3,79.41,47.3,92.18c0,20.8,9.43,33.35,16.42,39.19-2.32.21-4.52.44-6.63.71-19.24,2.45-19.21,12.78-19.18,24.74v3.63H139.48v-3.63c0-12,.06-22.29-19.17-24.74-2.11-.27-4.31-.5-6.63-.71,7-5.84,16.42-18.39,16.42-39.19,0-20.46-13.49-35.94-22.13-44.54l-1.82-1.82L104.84,48c-1.5,2.53-8.82,14.46-9.13,44.61H82c.48-45,18-62,18.18-62.16l.65-.65-.07-.91a13,13,0,0,0-12.9-12Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M115.68,57.6c22.72,55.13-27.07,71.83-27.07,71.83l25.07,1.94c-2.44,1.85,16-5.24,16-41.36A43.76,43.76,0,0,0,115.68,57.6Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M81.45,38.77c-2.67-1.22-28.61,20.58-32.9,42.92-4,20.81,3.2,26.56,2.77,26.39,0-.13,2.78-45.8,32.83-68.11C84.15,40,83,39.47,81.45,38.77Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M89.65,18.84c-4.34.39-11.78,6.67-12.4,15.35,0,0-6-5.57.06-12.49C82.05,16.24,89.65,18.84,89.65,18.84Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M88.7,138.41c43.07,0,47.54,4.75,47.54,4.75h.59c-1.93-10.18-24.5-11.3-24.5-11.3H65.23s-23.36.81-24.66,11.3h.59S45.63,138.41,88.7,138.41Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M86.73,57c1.84-5.06,14.08-29,14.08-29l-5.54-9.19-2.87.06c9.19,11.26-18,37-18,56.43,0,5.69,1.39,17.22,5.53,19.31C80,94.65,82.91,67.54,86.73,57Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M87.82,18.94A10.94,10.94,0,0,1,98.73,29.07S80,46.81,80,94.65H97.7c0-29.93,7-42.36,8.86-45.59,9.46,9.42,21.54,24,21.54,43.12,0,26.23-15.31,38.41-20.33,40.76,4.33.27,8.43.63,12.29,1.12,18.25,2.33,17.42,11.29,17.42,24.39H39.92c0-13.1-.83-22.06,17.42-24.39,3.85-.49,8-.85,12.29-1.12-5-2.35-20.33-14.53-20.33-40.76,0-30.08,32.15-53.41,32.15-53.41a10.94,10.94,0,0,1,6.37-19.83m0-4A14.93,14.93,0,0,0,75.54,38.37,109.36,109.36,0,0,0,62.31,51.63c-11.13,13.28-17,27.3-17,40.55,0,18.39,7.2,30.63,13.88,37.63l-2.35.29c-21,2.67-20.95,14.35-20.92,26.73v5.62H141.48v-5.62c0-12.38.07-24.06-20.92-26.73-.77-.1-1.55-.2-2.34-.28,6.68-7,13.88-19.25,13.88-37.64,0-15.71-7.43-30.74-22.72-46l-3.65-3.63L103.12,47c-5.76,9.76-9,24.78-9.38,43.63H84c.5-21.46,5-36,8.75-44.55,4.32-9.79,8.7-14.09,8.74-14.13l1.35-1.3-.12-1.88a15,15,0,0,0-14.9-13.85Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M88.7,132.41c9,0,17.15.28,24.57.93l1.91-3.84c-7.68-.73-16.4-1.09-26.48-1.09h0c-10.19,0-19,.36-26.73,1.11l1.18,3.91C70.83,132.72,79.34,132.41,88.7,132.41Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWB);
export default __webpack_public_path__ + "static/media/wB.8916e1a25970980693a25ea63e3a8f80.svg";
export { ForwardRef as ReactComponent };